import { Component, OnInit } from '@angular/core';
import { FormField } from '../../../dto/util/form-field';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { AlertaModalService } from '../../../services/util/alerta-modal.service';
import { TranslateService } from '@ngx-translate/core';
import { Constants } from '../../../constants/constants';
import { combineLatest } from 'rxjs';
import { ListasService } from '../../../services/listas.service';
import { AnexoPrecargaResponseDto } from '../../../dto/anexo/anexo-tramite.dto';
import { TipoAnexoTipoTramiteDto } from '../../util/archivos-tramite/dto/tipo-anexo-tipo-tramite.dto';
import { ArchivoItemDto } from '../../util/archivos-tramite/dto/ArchivoItemDto';
import { TipoTramiteConstants } from '../../../constants/tipo-tramite.constants';
import { Router } from '@angular/router';
import { EmpresaService } from '../services/empresa.service';
import { EmpresaDto } from '../../../dto/empresa/empresa.dto';
import { ListaValorDto } from '../../../dto/expediente/lista-valor.dto';
import { TramiteService } from '../../../services/tramite.service';
import { EntidadInteroperabilidadDTO } from '../../tramites/models/entidadDTO';

@Component({
  selector: 'app-registro-empresa',
  templateUrl: './registro-empresa.component.html',
  styleUrl: './registro-empresa.component.scss'
})
export class RegistroEmpresaComponent implements OnInit {

  // Multilenguaje
  tramitesText: any = {};
  comunText: any = {};
  alertaText: any = {};
  empresaText: any = {};

  formFieldsEmpresa: FormField[] = [];
  formEmpresa!: FormGroup;

  // Archivos
  mostrarComponenteCarga: boolean = true;
  archivosPrecargado?: AnexoPrecargaResponseDto[] = [];
  todosArchivosValidos: boolean = false;
  entidadId: number = Constants.ID_ENTIDAD_SIC;

  // Tramite
  tipoTramite: number = TipoTramiteConstants.ID_TRAMITE_SIC_PROIND_COMDES;
  idTramite!: number | null;
  idTramiteSsoRoi!: number;
  enviarDocumentos: boolean = false;
  enviarEntidad: boolean = false;
  archivosCargados: ArchivoItemDto[] = [];
  pesoTotalArchivosMB: string = '0.00';
  pesoTotalGB: number = 0;
  valorMaximoGB: number = Constants.TAMANIO_MAXIMO_ARCHIVOS_MBYTES;
  estadoSolicitud: ListaValorDto[] = [];
  entidades: EntidadInteroperabilidadDTO[] = [];
  servicioRUESDisponible: boolean = false;

  constructor(
    private readonly fb: FormBuilder,
    private readonly alertaModalService: AlertaModalService,
    private readonly translate: TranslateService,
    private listasService: ListasService,
    private router: Router,
    private readonly empresaService: EmpresaService,
    private readonly tramiteService: TramiteService
  ) {
  }

  ngOnInit() {
    this.cargarEntidades();
    this.getTiposDocumento();
    combineLatest({
      tramites: this.translate.stream('tramites'),
      comun: this.translate.stream('comun-label'),
      alertas: this.translate.stream('alertas'),
      empresa: this.translate.stream('crear-empresa'),
    }).subscribe(({ tramites, comun, alertas, empresa }) => {
      // Asignar traducciones a variables
      this.tramitesText = tramites;
      this.comunText = comun;
      this.alertaText = alertas;
      this.empresaText = empresa;
      // Construir formularios después de cargar traducciones
      this.buildForms();
    });
    this.getListas();
    this.formEmpresa = this.fb.group({});
  }

  getTiposDocumento() {
    // NATURAL
    this.listasService.getDocumentTypeListByPersonType(
      Constants.TIPO_PERSONA.NATURAL.toString(),
      this.entidadId).subscribe(response => {

        const tipoDocumentEmpresa = this.formFieldsEmpresa.find(f => f.name === 'tipoDocumentRl');
        if (tipoDocumentEmpresa) {
          tipoDocumentEmpresa.options = response
            .filter((item: any) => item.Tipo_Documento !== 'TI')
            .map((item: any) => ({
              Id: item.Id,
              Nombre: item.Descripcion
            }));
        }
      });

    // JURIDICA (Representante Legal)
    this.listasService.getDocumentTypeListByPersonType(
      Constants.TIPO_PERSONA.JURIDICA.toString(),
      this.entidadId).subscribe(response => {

        const tipoDocumentRl = this.formFieldsEmpresa.find(f => f.name === 'tipoDocument');
        if (tipoDocumentRl) {
          tipoDocumentRl.options = response.map((item: any) => ({
            Nombre: item.Descripcion,
            Id: item.Id
          }));
        }
      });
  }

  cargarEntidades(): void {
    this.tramiteService.listaEntidadesPublica().subscribe({
      next: (entidades: EntidadInteroperabilidadDTO[]) => {
        const servicioRUES = entidades.find(
          entidad => entidad.Codigo_Tipo_Tramite === 'RUES_CONSULTA_PJ'
        );

        this.servicioRUESDisponible = servicioRUES?.Servicio_Disponible ?? false;
        console.log('RUES disponible:', this.servicioRUESDisponible);
      },
      error: (error) => {
        console.error('Error al cargar entidades:', error);
        this.servicioRUESDisponible = false;
      }
    });
  }

  getListas() {
    this.listasService.listaValorPublico(Constants.TIPO_SOCIEDAD).subscribe(response => {
    })
    this.listasService.listaValorPublico(Constants.ESTADO_SOLICITUD_EMPRESA).subscribe(response => {
      this.estadoSolicitud = response;
    })
  }

  buildForms() {
    this.formFieldsEmpresa = [
      {
        name: 'tipoDocument',
        label: this.comunText['tipo-documento'],
        type: 'select',
        required: true,
        options: [],
        width: '6',
        visible: true,
        errorMessages: { required: this.comunText['tipo-documento-required'] },
      },
      {
        name: 'numberOfDocument',
        label: this.comunText['nit'],
        type: 'text',
        required: true,
        placeholder: this.comunText['numero-documento-placeholder'],
        width: '6',
        visible: true,
        modalVisibility: true,
        titleModal: this.comunText['ver-mas'],
        sizeModal: 'sm',
        contentTypeModal: 'text',
        contentModalText: this.empresaText['sin-puntos'],
        validation: [
          Validators.maxLength(11),
          Validators.pattern(Constants.REGEX_NIT_CON_DV)
        ],
        errorMessages: {
          required: this.comunText['numero-documento-required'],
          maxlength: this.tramitesText['tramite-sic-procon']['nit-maxlength'],
          pattern: this.tramitesText['tramite-sic-procon']['identificacion-pattern'],
        },
      },
      {
        name: 'razonSocial',
        label: this.comunText['razon-social'],
        type: 'text',
        required: true,
        placeholder: this.comunText['razon-social-placeholder'],
        width: '12',
        visible: true,
        modalVisibility: true,
        titleModal: this.empresaText['modal-razon-social'],
        sizeModal: 'sm',
        contentTypeModal: 'text',
        contentModalText: this.empresaText['mensaje-razon-social'],
        validation: [
          Validators.minLength(3),
          Validators.maxLength(50),
          Validators.pattern(Constants.REGEX_ALPHANUMERIC_RAZON_SOCIAL),
        ],
        errorMessages: {
          required: this.comunText['razon-social-required'],
          minlength: this.comunText['razon-social-minlength'],
          maxlength: this.comunText['razon-social-maxlength-50'],
          pattern: this.comunText['razon-social-pattern'],
        },
      },
      {
        name: 'tipoDocumentRl',
        label: this.empresaText['tipo-documento-rl'],
        type: 'select',
        required: true,
        options: [],
        width: '6',
        visible: true,
        errorMessages: { required: this.comunText['tipo-documento-required'] },
      },
      {
        name: 'numberOfDocumentRl',
        label: this.empresaText['documento-rl'],
        type: 'text',
        required: true,
        placeholder: this.comunText['numero-documento-placeholder'],
        width: '6',
        visible: true,
        validation: [
          Validators.minLength(4),
          Validators.pattern(Constants.REGEX_TELEFONO),
        ],
        errorMessages: {
          required: this.comunText['numero-documento-required'],
        },
      },
      {
        name: 'email',
        label: this.comunText['email'],
        type: 'email',
        required: true,
        placeholder: this.comunText['email-placeholder'],
        width: '6',
        visible: true,
        modalVisibility: true,
        titleModal: this.empresaText['modal-correo'],
        sizeModal: 'lg',
        contentTypeModal: 'text',
        contentModalText: this.empresaText['informacion-correo'],
        validation: [
          Validators.pattern(Constants.REGEX_CORREO_ELECTRONICO),
          Validators.maxLength(100),
        ],
        errorMessages: {
          required: this.comunText['correo-required'],
          pattern: this.comunText['email-pattern'],
          maxlength: this.comunText['email-maxlength'],
        },
      },
    ];
  }


  validarFormulario(formGroup: FormGroup) {
    if (formGroup) {
      this.formEmpresa = formGroup;
    }

  }

  onChangeValidarFormulario($event: {
    controlName?: string;
    controlValue: unknown;
    form: FormGroup;
  }) {
    const formGroup = $event.form;

    // ============================================
    // EMPRESA - Validación de documento
    // ============================================
    const idTipoDocumento: number = +formGroup?.get('tipoDocument')?.value;
    let identificacion: string = formGroup?.get('numberOfDocument')?.value || '';
    const numeroDocumentoEmpresa = this.formFieldsEmpresa.find(
      field => field.name == 'numberOfDocument'
    );

    if (
      $event.controlName == 'tipoDocument' ||
      $event.controlName == 'numberOfDocument'
    ) {
      if (idTipoDocumento !== null && identificacion !== null) {
        if (idTipoDocumento == Constants.TIPOS_DOCUMENTOS_PERSONAS.NIT) { // Es NIT
          if (numeroDocumentoEmpresa != undefined) {
            formGroup
              .get('numberOfDocument')
              ?.setValidators([
                Validators.required,
                Validators.maxLength(11), // 11 para incluir el guión y DV (9 dígitos + guión + 1 dígito)
                Validators.pattern(/^\d{1,9}(-\d)?$/), // Permite números con o sin guión-DV
              ]);
            numeroDocumentoEmpresa.errorMessages!['maxlength'] =
              this.tramitesText['tramite-sic-procon']['nit-maxlength'];
            numeroDocumentoEmpresa.errorMessages!['pattern'] =
              this.tramitesText['tramite-sic-procon']['identificacion-pattern'];
          }

          // Calcular y agregar dígito de verificación automáticamente
          if ($event.controlName == 'numberOfDocument') {
            // Remover el DV actual si existe
            const nitSinDV = identificacion.split('-')[0];

            // Solo calcular si hay un NIT válido (solo números, sin guión)
            if (nitSinDV && /^\d+$/.test(nitSinDV) && nitSinDV.length >= 1) {
              const dv = this.calcularDigitoVerificacion(nitSinDV);
              const nitCompleto = `${nitSinDV}-${dv}`;

              // Actualizar el valor del campo sin disparar el evento nuevamente
              if (identificacion !== nitCompleto) {
                formGroup.get('numberOfDocument')?.setValue(nitCompleto, { emitEvent: false });
              }
            }
          }
        } else {
          // No es NIT, restaurar validaciones normales
          if (numeroDocumentoEmpresa != undefined) {
            formGroup
              .get('numberOfDocument')
              ?.setValidators([
                Validators.required,
                Validators.maxLength(11),
                Validators.pattern(Constants.REGEX_NIT_CON_DV),
              ]);
            numeroDocumentoEmpresa.errorMessages!['maxlength'] =
              this.tramitesText['tramite-sic-procon']['nit-maxlength'];
            numeroDocumentoEmpresa.errorMessages!['pattern'] =
              this.tramitesText['tramite-sic-procon']['identificacion-pattern'];
          }
        }

        formGroup?.get('numberOfDocument')?.updateValueAndValidity({ emitEvent: false });
      }
    }

    // ============================================
    // REPRESENTANTE LEGAL - Validación de documento
    // ============================================
    const idTipoDocumentoRl: number = +formGroup?.get('tipoDocumentRl')?.value;
    const identificacionRl: number = +formGroup?.get('numberOfDocumentRl')?.value;
    const numeroDocumentoRl = this.formFieldsEmpresa.find(
      field => field.name == 'numberOfDocumentRl'
    );

    if (
      $event.controlName == 'tipoDocumentRl' ||
      $event.controlName == 'numberOfDocumentRl'
    ) {
      if (idTipoDocumentoRl !== null && identificacionRl !== null) {
        // CC, CE o NIT
        if ([
          Constants.TIPOS_DOCUMENTOS_PERSONAS.CC,
          Constants.TIPOS_DOCUMENTOS_PERSONAS.CE,
          Constants.TIPOS_DOCUMENTOS_PERSONAS.NIT
        ].includes(idTipoDocumentoRl)) {
          if (numeroDocumentoRl != undefined) {
            formGroup
              .get('numberOfDocumentRl')
              ?.setValidators([
                Validators.required,
                Validators.minLength(Constants.MIN_LENGTH_IDENTIFICACION),
                Validators.maxLength(Constants.MAX_LENGTH_IDENTIFICACION),
                Validators.pattern(/^\d+$/),
              ]);
            numeroDocumentoRl.errorMessages!['minlength'] =
              this.comunText['numero-documento-minlength'];
            numeroDocumentoRl.errorMessages!['maxlength'] =
              this.comunText['numero-documento-maxlength'];
            numeroDocumentoRl.errorMessages!['pattern'] =
              this.comunText['numero-documento-pattern'];
          }
        }
        // PASAPORTE
        else if (
          idTipoDocumentoRl == Constants.TIPOS_DOCUMENTOS_PERSONAS.PASAPORTE
        ) {
          if (numeroDocumentoRl != undefined) {
            formGroup
              .get('numberOfDocumentRl')
              ?.setValidators([
                Validators.required,
                Validators.minLength(Constants.MIN_LENGTH_IDENTIFICACION),
                Validators.maxLength(Constants.MAX_LENGTH_IDENTIFICACION_PA),
              ]);
            numeroDocumentoRl.errorMessages!['minlength'] =
              this.comunText['numero-documento-minlength-ce'];
            numeroDocumentoRl.errorMessages!['maxlength'] =
              this.comunText['numero-documento-maxlength-ce'];
            numeroDocumentoRl.errorMessages!['pattern'] =
              this.comunText['numero-documento-pattern-ce'];
          }
        }

        formGroup?.get('numberOfDocumentRl')?.updateValueAndValidity();
      }
    }
  }

  // Archivos

  subirArchivo(subio: any) {
    this.enviarDocumentos = false;
  }

  getFlagFileValidos(flag: boolean) {
    this.todosArchivosValidos = flag;
  }

  validarArchivosCargados(archivos: ArchivoItemDto[]) {
    this.archivosCargados = archivos;
    const totalBytes = archivos.reduce(
      (total, archivo) => total + archivo.files.reduce((sum, file) => sum + file.size, 0),
      0
    );
    this.pesoTotalArchivosMB = (totalBytes / Constants.BYTES_POR_MB).toFixed(2);
    if (parseFloat(this.pesoTotalArchivosMB) > Constants.TAMANIO_MAXIMO_ARCHIVOS_MBYTES) {
      this.alertaModalService.error(
        `${this.empresaText['peso-archivo']} (${this.pesoTotalArchivosMB} MB) ` +
        `${this.empresaText['limite-archivo']} ${Constants.TAMANIO_MAXIMO_ARCHIVOS_MBYTES} MB.`
      );
    }
  }

  isNotEmptyObligatorio(): boolean {

    if (this.archivosCargados.length == 0) {
      return false;
    } else {
      return this.todosArchivosValidos;
    }
  }

  // enviar
  finalizar(): void {

    // 1. Validar formulario
    if (this.formEmpresa.invalid) {
      this.formEmpresa.markAllAsTouched();
      this.alertaModalService.error(
        this.alertaText['error'],
        this.alertaText['form_invalid']
      );
      return;
    }

    // 2. Validar anexos obligatorios
    const anexosCompletos = this.isNotEmptyObligatorio();
    console.log("anexosCompletos ", anexosCompletos);

    if (!anexosCompletos) {
      this.alertaModalService.error(
        this.alertaText['error'],
        this.alertaText['archivos_obligatorios']
      );
      return;
    }

    // 3. Validar peso máximo
    if (parseFloat(this.pesoTotalArchivosMB) > this.valorMaximoGB) {
      this.alertaModalService.error(
        `${this.empresaText['peso-archivo']} (${this.pesoTotalArchivosMB} MB) ` +
        `${this.empresaText['limite-archivo']} ${Constants.TAMANIO_MAXIMO_ARCHIVOS_MBYTES} MB.`
      );
      return;
    }

    // 4. Todo válido -> Continuar
    this.enviarSolicitud();
  }

  enviarSolicitud() {
    // Logica de guardado
    const form = this.formEmpresa.value;
    const idEstado: number = this.estadoSolicitud.find(elemento => elemento.Valor == Constants.PENDIENTE)?.Id!;

    // Extraer el NIT sin el dígito de verificación
    const nitCompleto = form.numberOfDocument;
    const nitSinDV = nitCompleto ? nitCompleto.split('-')[0] : '';

    const solicitud: EmpresaDto = {
      idPersonaJuridica: {
        idTipoPersona: Constants.TIPO_PERSONA.JURIDICA,
        idTipoIdentificacion: Constants.TIPOS_DOCUMENTOS_PERSONAS.NIT,
        razonSocial: form.razonSocial,
        identificacion: nitSinDV,
        tipoSociedad: {
          id: undefined
        },
        datosRepresentanteLegal: {
          idTipoPersona: Constants.TIPO_PERSONA.NATURAL,
          idTipoIdentificacion: form.tipoDocumentRl,
          identificacion: form.numberOfDocumentRl,
          primerNombre: '',
          primerApellido: ''
        }
      },
      correoNotificacion: form.email,
      idEstadoSolicitud: {
        id: idEstado,
      }
    };

    const formData = new FormData();

    formData.append('solicitud', JSON.stringify(solicitud));
    this.archivosCargados.forEach(archivoItem => {
      const tipoAnexoId = archivoItem.item.tipoAnexo?.id;
      archivoItem.files.forEach(file => {
        // obtener nombre original
        const originalName = file.name;
        // extraer extensión
        const extension = originalName.substring(originalName.lastIndexOf('.'));
        // quitar extensión del nombre base
        const baseName = originalName.substring(0, originalName.lastIndexOf('.'));
        // construir nombre final: tipoAnexoId-baseName.ext
        const newFileName = `${tipoAnexoId}-${baseName}${extension}`;
        // agregar al FormData con el nuevo nombre
        formData.append('archivos', file, newFileName);
      });
    });

    this.empresaService.crearSolicitudEmpresa(formData).subscribe({
      next: (resp: any) => {
        if (this.servicioRUESDisponible) {
          this.empresaService.notificacion(resp.Id, true).subscribe({
            next: (response) => {
              this.router.navigateByUrl('/pasos-seguir');
            },
            error: (err) => {
              console.error('Error al enviar notificación:', err);
              this.router.navigateByUrl('/pasos-seguir');
            }
          });
        } else {
          console.log('Notificación omitida - Servicio RUES no disponible');
          this.router.navigateByUrl('/pasos-seguir');
        }
      },
      error: (err) => {
        this.alertaModalService.error('Error al enviar la solicitud');
      }
    });
  }

  calcularDigitoVerificacion(nit: string): number {
    if (!nit || nit.length === 0) return Constants.NIT_DV_RESIDUO_CERO;

    const pesos = Constants.NIT_DV_PESOS;
    let suma = 0;

    // Recorrer el NIT de derecha a izquierda
    for (let i = 0; i < nit.length; i++) {
      const digito = parseInt(nit[nit.length - 1 - i]);
      suma += digito * pesos[pesos.length - 1 - i];
    }

    const residuo = suma % Constants.NIT_DV_DIVISOR;

    if (residuo === Constants.NIT_DV_RESIDUO_CERO) return Constants.NIT_DV_RESIDUO_CERO;
    if (residuo === Constants.NIT_DV_RESIDUO_UNO) return Constants.NIT_DV_RESIDUO_UNO;
    return Constants.NIT_DV_DIVISOR - residuo;
  }
}
